import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { TypedMemo } from '../../common/types';
import { SMLPageMenu } from './SMLPageMenu';
import styles from './SMLPageActions.module.scss';

interface SMLPageActionsProps {
  onEdit: () => void;
  onOpen: () => void;
  onDuplicate: () => void;
  onChangeAddress: () => void;
  onEmbed?: () => void;
  onExportPresaves?: () => void;
  isExportLocked?: boolean;
  onUnpublish?: () => void;
  onDelete?: () => void;
}

/**
 * The header's actions, ranked.
 *
 * Four equal buttons made the artist read all four every visit, and put an
 * irreversible one within a stray click of the one they wanted. Editing is
 * what they came to do, so it is the only filled button; opening the page is
 * the check they make after; everything else waits behind the ⋯.
 */
const SMLPageActionsComponent: React.FC<SMLPageActionsProps> = ({
  onEdit,
  onOpen,
  onDuplicate,
  onChangeAddress,
  onEmbed,
  onExportPresaves,
  isExportLocked,
  onUnpublish,
  onDelete,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.actions}>
      <SMLPageMenu
        onDuplicate={onDuplicate}
        onChangeAddress={onChangeAddress}
        onEmbed={onEmbed}
        onExportPresaves={onExportPresaves}
        isExportLocked={isExportLocked}
        onUnpublish={onUnpublish}
        onDelete={onDelete}
      />
      <button type="button" className={styles.secondary} onClick={onOpen}>
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        {intl.formatMessage({ id: 'app.sml.details.open', defaultMessage: 'Open' })}
      </button>
      <button type="button" className={styles.primary} onClick={onEdit}>
        <FontAwesomeIcon icon={faPen} />
        {intl.formatMessage({ id: 'app.sml.details.edit', defaultMessage: 'Edit page' })}
      </button>
    </div>
  );
};

export const SMLPageActions = TypedMemo(SMLPageActionsComponent);
